import {dateTimeStringFromApiToDate, nullableDateTimeStringFromApiToDate} from "../../../index";

export class DashboardForloebModel {
    brugerId: string
    forloebId: string
    brugernavn: string
    specialenavn: string
    specialeColor: string
    specialeId: string
    uddannelsestype: number
    uddannelseId: string
    evalueretDato?: Date
    forloebSlutDato: Date

    static Build(responseModel: DashboardForloebResponseModel): DashboardForloebModel {
        let model = new DashboardForloebModel();
        model.brugerId = responseModel.brugerId;
        model.forloebId = responseModel.forloebId;
        model.brugernavn = responseModel.brugernavn;
        model.specialenavn = responseModel.specialenavn;
        model.specialeColor = responseModel.specialeColor;
        model.specialeId = responseModel.specialeId;
        model.uddannelsestype = responseModel.uddannelsestype;
        model.uddannelseId = responseModel.uddannelseId;
        model.evalueretDato = nullableDateTimeStringFromApiToDate(responseModel.evalueretDato);
        model.forloebSlutDato = dateTimeStringFromApiToDate(responseModel.forloebSlutDato);
        return model;
    }
}

export type DashboardForloebResponseModel = {
    forloebId: string
    brugerId: string
    brugernavn: string
    specialenavn: string
    specialeColor: string
    specialeId: string
    uddannelsestype: number
    uddannelseId: string
    evalueretDato?: string
    forloebSlutDato: string
}
